import { DashboardEventTypes, track } from '~/src/dash/analytics/analytics';
import { IUser } from '~/src/dash/api/console-api';
import { hasRoleSuperUser } from '~/src/dash/utils/roles';

interface IIASMeasurementTrackEventProps {
  eventTitle: DashboardEventTypes | '';
  graphID?: number;
  startDate?: string;
  endDate?: string;
  compStartDate?: string;
  compEndDate?: string;
  timezone?: string;
  timeToLoadSec?: number;
  queryFailed?: boolean;
  queryDurationDays?: number;
  queryDuration?: number;
  compQueryDurationDays?: number;
}

export const IASMeasurementTrackEvent = (
  user: IUser,
  {
    eventTitle = '',
    graphID = 0,
    startDate = '',
    endDate = '',
    // compStartDate = '',
    // compEndDate = '',
    // compQueryDurationDays = 0,
    // compareEnabled = false,
    timezone = '',
    timeToLoadSec = 0,
    queryFailed = false,
    queryDuration = 0,
    queryDurationDays = 0,
  }: IIASMeasurementTrackEventProps,
) => {
  const is_super_user = hasRoleSuperUser(user);
  if (
    eventTitle === 'IAS Measurement Drill Dashboard - Open Calendar' ||
    eventTitle === 'IAS Measurement Drill Dashboard - View' ||
    eventTitle === 'IAS Measurement Drill Dashboard - Open Filter Pill' ||
    eventTitle === 'IAS Measurement Drill Dashboard - Click Breadcrumb'
  ) {
    track(
      eventTitle,
      {
        is_super_user,
        // compareEnabled: isComparedToEnabled,
      },
      user,
    );
  } else if (
    eventTitle === 'IAS Publisher Dashboard - Run Agg Query' ||
    eventTitle === 'IAS Measurement Drill Dashboard - Run Chart Agg Query'
  ) {
    track(
      eventTitle,
      {
        is_super_user,
        graphID,
        startDate,
        endDate,
        // compStartDate,
        // compEndDate,
        timezone,
        timeToLoadSec,
        queryFailed,
        queryDuration,
        queryDurationDays,
        // compQueryDurationDays,
        // compareEnabled,
      },
      user,
    );
  }
};
